import { render, staticRenderFns } from "./UserProjectList.vue?vue&type=template&id=5bc9e0ae&scoped=true&"
import script from "./UserProjectList.vue?vue&type=script&lang=ts&"
export * from "./UserProjectList.vue?vue&type=script&lang=ts&"
import style0 from "./UserProjectList.vue?vue&type=style&index=0&id=5bc9e0ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc9e0ae",
  null
  
)

/* custom blocks */
import block0 from "./UserProjectList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports